export const table = {
  header:
    "px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider",
  data: "px-6 py-4 whitespace-nowrap text-sm text-neutral-500",
};

export const mediaQueries = {
  widescreen: { minWidth: 1024 },
};

// Used in TipTap config, if changing also update in tailwind.config.js
export const primaryColor = "#32746e";
